import * as i18nIsoCountries from 'i18n-iso-countries';
import * as langs from '@cospired/i18n-iso-languages';

langs.registerLocale(require('@cospired/i18n-iso-languages/langs/fr.json'));
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'));

// export const languagesOptions = () => {
// 	const languages = langs.getNames('fr');
// 	return Object.keys(languages)
// 		.map((code) => {
// 			return {
// 				value: code,
// 				label: `${code} - ${languages[code]}`,
// 				language: code,
// 				top: false,
// 			};
// 		})
// 		.reduce((acc, element) => {
// 			const promotedLanguages = process.env.REACT_APP_PROMOTED_LANG.split(' ');
// 			if (promotedLanguages.includes(element.value)) {
// 				return [
// 					{
// 						...element,
// 						top: true,
// 						position: promotedLanguages.indexOf(element.value),
// 					},
// 					...acc,
// 				];
// 			}
// 			return [...acc, element];
// 		}, [])
// 		.sort((a, b) => {
// 			if (a.top && !b.top) return -1;
// 			else if (!a.top && b.top) return 1;
// 			else if (a.top && b.top) return a.position - b.position;
// 			else return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
// 		});
// };

export const languagesOptions = () => {
	const languageCodes = process.env.REACT_APP_LANG.split(' ');
	const languages = [];
	languageCodes.forEach((code) =>
		languages.push({
			value: code,
			label: `${code} - ${langs.getName(code, 'fr')}`,
			language: code,
		})
	);

	return languages;
};

export const countriesOptions = () => {
	var countiesObject = i18nIsoCountries.getNames('fr');
	var countries = Object.keys(countiesObject).map(function (key) {
		return [key, countiesObject[key]];
	});
	return countries
		.map((country) => {
			return {
				value: country[0],
				label: country[1],
				top: false,
			};
		})
		.reduce((acc, element) => {
			const promotedCountries = process.env.REACT_APP_PROMOTED_COUNTRIES.split(
				' '
			);
			if (promotedCountries.includes(element.value)) {
				return [
					{
						...element,
						top: true,
						position: promotedCountries.indexOf(element.value),
					},
					...acc,
				];
			}
			return [...acc, element];
		}, [])
		.sort((a, b) => {
			if (a.top && !b.top) return -1;
			else if (!a.top && b.top) return 1;
			else if (a.top && b.top) return a.position - b.position;
			else {
				const labelA = removeAccents(a.label);
				const labelB = removeAccents(b.label);
				return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
			}
		});
};

export const orderedSpecialRegimes = (specialRegimes) => {
	return specialRegimes
		.map((specialRegime) => {
			return {
				value: specialRegime.id,
				label: `${specialRegime.acronym} - ${specialRegime.name}`,
				geslab_id: specialRegime.geslab_id,
				top: false,
			};
		})
		.reduce((acc, element) => {
			const promotedSpecialRegimes = process.env.REACT_APP_PROMOTED_SPECIAL_REGIMES.split(
				' '
			);
			if (promotedSpecialRegimes.includes(element.geslab_id)) {
				return [
					{
						...element,
						top: true,
						position: promotedSpecialRegimes.indexOf(element.value),
					},
					...acc,
				];
			}
			return [...acc, element];
		}, [])
		.sort((a, b) => {
			if (a.top && !b.top) return -1;
			else if (!a.top && b.top) return 1;
			else if (a.top && b.top) return a.position - b.position;
			else {
				const labelA = removeAccents(a.label);
				const labelB = removeAccents(b.label);
				return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
			}
		});
};

export const doctorHandleInputChange = (value, oldValue) => {
	const regex = new RegExp(/^[0-9]{6}$/);
	if (regex.test(value) && oldValue.slice(-1) !== '-') {
		return `${value}-`;
	}
	return value;
};

const removeAccents = (str) => {
	let accents =
		'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
	let accentsOut =
		'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
	str = str.split('');
	str.forEach((letter, index) => {
		let i = accents.indexOf(letter);
		if (i !== -1) {
			str[index] = accentsOut[i];
		}
	});
	return str.join('');
};
